import { render, staticRenderFns } from "./teacherwageinfomode.vue?vue&type=template&id=c01e0696"
import script from "./teacherwageinfomode.vue?vue&type=script&lang=js"
export * from "./teacherwageinfomode.vue?vue&type=script&lang=js"
import style0 from "./teacherwageinfomode.vue?vue&type=style&index=0&id=c01e0696&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports